export default "__VITE_ASSET__BdSevNzt__"